<template>
  <div id="app" class="body-container">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive"></router-view>
    <div v-show="loading" class="lz-readys">
      <div class="spinner">
        <div class="spinner-container container1">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container2">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
        <div class="spinner-container container3">
          <div class="circle1"></div>
          <div class="circle2"></div>
          <div class="circle3"></div>
          <div class="circle4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
require("static/css/animate.min.css");
require("@static/iconfont/iconfont.css");
// import Vconsole from 'Vconsole'
import common from "./api/common";
export default {
  name: "App",
  data() {
    return {
      loading: false,
      appLoad: false, //app api是否就绪
      user: {}
    };
  },
  created() {},
  methods: {
    setToken(){
      if(this.$route.query.token){
        localStorage.token = this.$route.query.token;
      }
    }
  },
  beforeCreate() {
    this.$router.onReady(() => {
      this.setToken&&this.setToken();
    });
  },
  mounted() {}
};
</script>

<style lang="scss">
#app {
  width: 100%;
  max-width: 10rem;
  min-height: 100%;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
}
#app>div {
  flex:1;
}
</style>
